var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpcCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2145 0.813691C14.9275 0.654007 14.6119 0.552458 14.2856 0.514851C13.9594 0.477244 13.6289 0.504317 13.3131 0.594522C12.9974 0.684727 12.7025 0.836294 12.4453 1.04056C12.1882 1.24482 11.9738 1.49777 11.8145 1.78494L7.17322 10.1374L4.51697 7.48119C4.28635 7.24242 4.01049 7.05196 3.70548 6.92094C3.40047 6.78992 3.07242 6.72095 2.74047 6.71807C2.40853 6.71518 2.07933 6.77844 1.77209 6.90414C1.46484 7.02984 1.18571 7.21547 0.950983 7.4502C0.716251 7.68494 0.530619 7.96407 0.404916 8.27131C0.279214 8.57855 0.21596 8.90775 0.218844 9.23969C0.221729 9.57164 0.290695 9.89969 0.421717 10.2047C0.55274 10.5097 0.743195 10.7856 0.98197 11.0162L5.98197 16.0162C6.45447 16.4899 7.09197 16.7499 7.74947 16.7499L8.09572 16.7249C8.47891 16.6713 8.84442 16.5295 9.1635 16.3107C9.48257 16.0918 9.74648 15.8019 9.93447 15.4637L16.1845 4.21369C16.344 3.92676 16.4455 3.6112 16.4831 3.28504C16.5207 2.95888 16.4937 2.62851 16.4037 2.31279C16.3136 1.99707 16.1622 1.70218 15.9582 1.44496C15.7541 1.18774 15.5014 0.973238 15.2145 0.813691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpcCheckmarkIcon);
export default __webpack_public_path__ + "static/media/cpc-checkmark-icon.ff4f195f6c4334513b722040d3c1ff4f.svg";
export { ForwardRef as ReactComponent };